import React, { useCallback } from "react";
import { Loading, TextField } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { TitleSourceBadge } from "./TitleSourceBadge";
import css from "./MergeDuplicateTitles.module.css";
var REASON_LABEL_IDS = {
    SAME_IDENTIFIER: "ui-br-legaldeposits.titleMerge.reason.sameIdentifier",
    SIMILAR_NAME_SAME_PUBLISHER: "ui-br-legaldeposits.titleMerge.reason.similarNameSamePublisher",
    SIMILAR_NAME: "ui-br-legaldeposits.titleMerge.reason.similarName",
};
export var candidateSubtitle = function (candidate) {
    var _a, _b;
    return [
        candidate.author,
        candidate.publisher,
        (_a = candidate.publicationYear) === null || _a === void 0 ? void 0 : _a.toString(),
        ((_b = candidate.identifiers) !== null && _b !== void 0 ? _b : []).join(", "),
    ]
        .filter(Boolean)
        .join(" · ");
};
export var MergeCandidatePicker = function (_a) {
    var search = _a.search, onSearchChange = _a.onSearchChange, candidates = _a.candidates, isLoading = _a.isLoading, isSearchable = _a.isSearchable, isTruncated = _a.isTruncated, candidateLimit = _a.candidateLimit, minSearchChars = _a.minSearchChars, setIds = _a.setIds, isFull = _a.isFull, onAdd = _a.onAdd;
    var formatMessage = useIntl().formatMessage;
    var handleChange = useCallback(function (event) {
        return onSearchChange(event.target.value);
    }, [onSearchChange]);
    return (React.createElement("div", { className: css.section, "data-test-id": "merge-picker" },
        React.createElement(TextField, { label: formatMessage({
                id: "ui-br-legaldeposits.titleMerge.picker.label",
            }), placeholder: formatMessage({
                id: "ui-br-legaldeposits.titleMerge.picker.placeholder",
            }), value: search, onChange: handleChange, marginBottom0: true, "data-test-id": "merge-picker-input" }),
        !isSearchable && search.length > 0 && (React.createElement("span", { className: css.hint },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.picker.minChars", values: { count: minSearchChars } }))),
        isLoading && React.createElement(Loading, null),
        isSearchable && !isLoading && candidates.length === 0 && (React.createElement("span", { className: css.hint },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.picker.noResults" }))),
        isSearchable && !isLoading && candidates.length > 0 && (React.createElement("div", { className: css.candidateList }, candidates.map(function (candidate) {
            var _a, _b;
            var inSet = setIds.includes(candidate.id);
            return (React.createElement("button", { type: "button", key: candidate.id, className: css.candidateRow, disabled: inSet || isFull, onClick: function () { return onAdd(candidate.id); }, "data-test-id": "merge-picker-add-".concat(candidate.id) },
                React.createElement(TitleSourceBadge, { source: candidate.source, provisional: candidate.provisional }),
                React.createElement("span", { className: css.candidateName },
                    candidate.mainName,
                    React.createElement("span", { className: css.candidateMeta }, " \u00B7 ".concat(candidateSubtitle(candidate)))),
                React.createElement("span", { className: "".concat(css.reasonBadge, " ").concat((_a = css["reason".concat(candidate.reason)]) !== null && _a !== void 0 ? _a : "") }, formatMessage({
                    id: (_b = REASON_LABEL_IDS[candidate.reason]) !== null && _b !== void 0 ? _b : "ui-br-legaldeposits.titleMerge.reason.other",
                })),
                React.createElement("span", { className: css.hint }, inSet ? (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.picker.inSet" })) : isFull ? (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.picker.full" })) : (React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.picker.add" })))));
        }))),
        isTruncated && (React.createElement("span", { className: css.hint },
            React.createElement(FormattedMessage, { id: "ui-br-legaldeposits.titleMerge.picker.truncated", values: { count: candidateLimit } })))));
};
